<script>
import FormCommons from './commons';
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  mixins: [FormCommons.MultiStepForm],
});
</script>
<template>
  <div
    class="cly-vue-form"
    @keyup.enter="() => { $emit('enter')}"
  >
    <slot
      name="default"
      v-bind="passedScope"
    />
  </div>
</template>
